import { AxiosResponse } from 'axios';
import { useInfiniteQuery, UseInfiniteQueryResult } from 'react-query';
import { UrlParams, PaginatedPayrollPeriodList } from 'types';
import { client } from 'utils/api-client';
import { encodeUrlParams, urlParamsFromUrl } from 'utils/functions';

interface QueryKeyType {
  pageParam?: UrlParams;
  queryKey: (string | undefined)[];
}

interface IUsePayrollPeriods {
  search?: string;
  ordering?: string;
  limit?: string;
  staff_id?: string;
}

function usePayrollPeriods({
  search,
  ordering,
  limit = '20',
  staff_id,
}: IUsePayrollPeriods): UseInfiniteQueryResult<AxiosResponse<PaginatedPayrollPeriodList>> {
  const fetchPayrollPeriods = ({
    pageParam = { limit, offset: '0' },
  }: QueryKeyType): Promise<AxiosResponse<PaginatedPayrollPeriodList>> => {
    const params = pageParam;

    if (search) {
      params.search = search;
    }

    if (ordering) {
      params.ordering = ordering.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);
    }

    if (staff_id) {
      params.staff_id = staff_id;
    }

    return client.get(`payroll-periods/?${encodeUrlParams(params)}`);
  };

  return useInfiniteQuery(['payrollPeriods', search, ordering, staff_id], fetchPayrollPeriods, {
    getNextPageParam: page => {
      return page.data.next ? urlParamsFromUrl(page.data.next) : undefined;
    },
  });
}

export default usePayrollPeriods;
